export interface TextItem {
    text: string;
}

export interface LabelItem {
    label: string;
    text?: string;
}

export const TooltipLabels: LabelItem[] = [
    {
        label: "品種  おす",
    },
    {
        label: "品種  めす",
    },
    {
        label: "都道府県",
    },
    {
        label: "常時母豚数",
        text: '<ul><li>月末在庫頭数を入力。</li><li>候補豚は初回交配した以降、数に含める。</li></ul>',
    },
    {
        label: "出荷頭数",
        text: '<ul><li>小貫も含む出荷頭数を入力。</li><li>廃用種豚、候補豚は除く。</li></ul>',
    },
    {
        label: "自家産の候補繰入頭数",
        text: '<ul><li>自家生産の候補豚繰り入れ頭数を入力。初回交配をもって繰り入れとする。</li></ul>',
    },
    {
        label: "出荷枝肉重量",
        text: '<ul><li>出荷枝肉重量を入力。</li><li>廃用種豚、候補豚は除く。</li></ul>',
    },
    {
        label: "a 総枝肉販売金額",
        text: '<ul><li>当月の枝肉総販売金額（消費税込、小数点以下切り捨て）を入力。</li><li>廃用母豚、候補豚、内臓は除く。</li></ul>',
    },
    {
        label: "b （内　と場経費）",
        text: '<ul><li>当月の総と場経費（消費税込、小数点以下切り捨て）を入力。</li><li>1頭当たりのと場経費の場合は「当月の出荷頭数×１頭当たりのと場経費」を入力。</li><li>農協、全農に支払う手数料及び輸送中の事故に掛けている共済金は含める。</li></ul>',
    },
    {
        label: "c （内　運賃）",
        text: '<ul><li>当月のと場への総運賃（消費税込、小数点以下切り捨て）を入力。</li><li>１頭当たりの運賃の場合「当月の出荷頭数×１頭当たりの運賃」を入力。</li><li>農家自身で配送した場合は「0円」を入力。</li></ul>',
    },
    {
        label: "d 総枝肉販売手取り金額",
        text: '<ul><li>生体販売による手取りを入力。（d=a-b-c）</li></ul>',
    },
    {
        label: "総飼料購入量 (全体)",
        text: '<ul><li>当月の購入量を入力。</li><li>棚卸は見ない。</li><li>ビタミン剤や生菌剤、飼料添加剤は除く。</li><li>リキッドを使用した場合は、乾物の合計重量を 0.87 で割った数値を入力。</li></ul>',
    },
    {
        label: "総飼料購入量 (種豚)",
        text: '<ul><li>総飼料購入量のうち、種豚のみに給餌する飼料に対しての購入量を入力。</li><li>棚卸は見ない。</li><li>ビタミン剤や生菌剤、飼料添加剤は除く。</li><li>リキッドを使用した場合は、乾物の合計重量を 0.87 で割った数値を入力。</li></ul>',
    },
    {
        label: "総飼料購入金額 (全体)",
        text: '<ul><li>総飼料購入金額（消費税込、小数点以下切り捨て）を入力。</li><li>棚卸は見ない。</li><li>純粋に餌にかかった費用のみを算出する。</li><li>自家配・エコフィードの場合、原料代のみを入力(サプリメント・プレミックスも含む)。</li><li>ビタミン剤や生菌剤、飼料添加剤は除く。</li><li>飼料購入の際のキャッシュバックは除く。</li></ul>',
    },
    {
        label: "飼料安定基金積立金",
        text: '<ul><li>実際に払い出しをした月にその金額を入力。</li></ul>',
    },
    {
        label: "飼料安定基金補填金",
        text: '<ul><li>実際に受け取った月にその金額を入力。</li><li>飼料安定基金以外の補助金の支払いは除く。</li></ul><a href="assets/file/JASVベンチマーキング飼料安定基金補填金欄の入力について.pdf" target="_blank"> → JASVベンチマーキング飼料安定基金補填金欄の入力について</a>',
    },
    {
        label: "総飼料購入金額 (種豚)",
        text: '<ul><li>総飼料購入金額のうち、種豚のみに給餌する飼料に対しての購入金額（消費税込、小数点以下切り捨て）を入力。</li><li>棚卸は見ない。</li><li>純粋に種豚の餌にかかった費用のみを算出する。</li><li>自家配・エコフィードの場合、原料代のみを入力(サプリメント・プレミックスも含む)。</li><li>ビタミン剤や生菌剤、飼料添加剤は除く。</li><li>飼料購入の際のキャッシュバックは除く。</li></ul>',
    },
    {
        label: "ワクチン・抗菌剤費",
        text: '<ul><li>当月のワクチンと抗菌剤の購入金額（消費税込、小数点以下切り捨て）を入力。</li><li>棚卸は見ない。</li><li>駆虫薬等も含める。</li><li>ホルモン剤は除く。</li></ul>',
    },
    {
        label: "離乳後の肉豚在庫頭数",
    },
    {
        label: "哺乳豚在庫頭数",
        text: '<ul><li>月末在庫頭数を入力。</li></ul>',
    },
    {
        label: "経営形態",
        text: '<ul><li>一貫農場のみを対象とする。</li></ul>',
    },
    {
        label: "離乳後事故頭数",
        text: '<ul><li>離乳後、肉豚の死亡、淘汰頭数を入力。</li></ul>',
    },
    {
        label: "種付頭数",
        text: '<ul><li>当月に交配した頭数を入力。</li></ul>',
    },
    {
        label: "分娩腹数",
        text: '<ul><li>当月に分娩した腹数を入力。</li><li>流産は除く。</li><li>早産の場合には、生存して分娩された子豚がいた場合は含める。</li></ul>',
    },
    {
        label: "総産子数",
        text: '<ul><li>当月に産まれた総産子数を入力。</li><li>ミイラ胎児、黒子、白子、虚弱豚、奇形などすべて含む。</li></ul>',
    },
    {
        label: "生存産子数",
        text: '<ul><li>当月に生存して産まれた子豚数を入力。</li><li>ミイラ胎児、黒子、白子等は除く。</li></ul>',
    },
    {
        label: "離乳子豚頭数",
        text: '<ul><li>当月に離乳した頭数を入力。</li></ul>',
    },
    {
        label: "養豚場従事者数",
        text: '<ul><li>当月末における農場の従事者数を入力。</li><li>農場で雇用しているトラック運転手、農場の修繕要員、事務員、経営者を含む農場運営に関わるすべての人数を入力。</li></ul>',
    },
    {
        label: "分娩クレート数",
        text: '<ul><li>分娩舎の総クレート数を入力。</li></ul>',
    },
    {
        label: "肥育面積",
        text: '<ul><li>廊下や資材置場も含めた、豚が飼育されている施設の総面積 (豚舎の縦×横)を入力。</li><li>離乳舎・肥育舎の合計を入力。</li><li>離乳舎→子豚舎→肥育舎など、離乳以降の豚舎が複数ある場合は、それらすべての合計を入力。</li></ul>',
    },
    {
        label: "PRRSの有無",
        text: '<ul><li>抗体検査・PCRのいずれかで、1頭でも「陽性」の場合は、その農場は「陽性」とする。</li><li>上記以外の場合、すなわち、抗体検査・PCRのどちらの検査でも、すべての豚が「陰性」の場合、その農場は「陰性」とする。</li></ul>',
    },
    {
        label: "子豚出荷頭数",
        text: '<ul><li>自農場で出産した子豚を他農場へ出荷した頭数を入力。</li></ul>',
    },
    {
        label: "子豚販売手取り金額",
        text: '<ul><li>当月に子豚を出荷したときの総販売手取り金額 (消費税込、小数点以下切り捨て)を入力。</li><li>運賃は除く。</li></ul>',
    },
    {
        label: "子豚出荷日齢",
        text: '<ul><li>子豚出荷時の平均日齢を入力。</li></ul>',
    },
];

export default TooltipLabels;
